// extracted by mini-css-extract-plugin
export default {"bodyPage":"rnQwaqVM2sTAvxZKQuFY","imageDiv":"Zn6Qe3JbvknAi8kCZBoA","ourStory":"gMR8FFv2HbOodtRA_DMA"};